import * as css from 'css/exports.module.scss';
import './InitiativesTableActionBar.scss';
import { ConfirmDeleteButton } from '@ui/modals';
import { InitiativeStatusSelector } from '../StatusSelector';
import { SearchInput } from '@ui/general';
import { UserSelector } from '@ui/UserSelector';
import { When } from 'react-if';
import { Checkbox, Space } from 'antd';
import { COPY_SPECIFIC, INITIATIVES_SEARCH_SETTINGS, PLACEHOLDERS_COPY } from '@sonar-software/sonar-ts-constants';
import { coreActions, FeatureFlag } from '@sonar-software/sonar-core';
import React, { useCallback } from 'react';
import { useAction, useCurrentUser, useFeatureFlag } from '@hooks';
export const InitiativesTableActionBar = ({ selectionData, onUpdate, queryParams }) => {
    var _a;
    const { selectAllEnabled, selectedKeys, selectedCount, resetSelection } = selectionData;
    const { id: userId } = useCurrentUser();
    const jiraIntegration = useFeatureFlag(FeatureFlag.JiraIntegration);
    const deleteInitiatives = useAction(coreActions.requestDeleteCoreInitiatives);
    const deleteBulkInitiatives = useAction(coreActions.requestDeleteCoreInitiativesBulk);
    const updateInitiatives = useAction(coreActions.requestPatchCoreInitiatives);
    const updateBulkInitiatives = useAction(coreActions.requestPatchCoreInitiativesBulk);
    const assignedTos = (_a = queryParams.assignedTos) !== null && _a !== void 0 ? _a : [];
    const assignedToMe = assignedTos.length === 1 && assignedTos[0] === userId;
    const handleOnSearch = useCallback((value) => {
        onUpdate({ title: value });
    }, [onUpdate]);
    const handleAssignToMeChange = useCallback(() => {
        onUpdate({ assignedTos: assignedToMe ? [] : [userId] });
    }, [assignedToMe, onUpdate, userId]);
    const handleBulkChange = useCallback((changes) => {
        const initiativeIds = selectedKeys.map((id) => Number(id));
        if (selectAllEnabled) {
            updateBulkInitiatives(Object.assign(Object.assign({}, queryParams), { initiativeIdsToExclude: initiativeIds, patchInitiativeDescription: Object.assign({}, changes) }));
        }
        else {
            updateInitiatives(Object.assign(Object.assign({}, queryParams), { initiativeIds, patchInitiativeDescription: Object.assign({}, changes) }));
        }
        resetSelection();
    }, [queryParams, resetSelection, selectAllEnabled, selectedKeys, updateBulkInitiatives, updateInitiatives]);
    const handleBulkArchive = useCallback(() => {
        const initiativeIds = selectedKeys.map((id) => Number(id));
        if (selectAllEnabled) {
            deleteBulkInitiatives(Object.assign(Object.assign({}, queryParams), { initiativeIdsToExclude: initiativeIds }));
        }
        else {
            deleteInitiatives({ initiativeIds });
        }
        resetSelection();
    }, [deleteBulkInitiatives, deleteInitiatives, queryParams, resetSelection, selectAllEnabled, selectedKeys]);
    return (React.createElement("div", { className: 'initiatives-table-action-bar' },
        React.createElement(Space, { size: Number(css.size16) },
            React.createElement(SearchInput, { debounceDelay: INITIATIVES_SEARCH_SETTINGS.SEARCH_DELAY, id: 'initiatives-table-search', onChange: handleOnSearch, placeholder: PLACEHOLDERS_COPY.SEARCH_BY_TITLE }),
            React.createElement(Checkbox, { checked: assignedToMe, id: 'initiative-table-self-assigned-filter', onChange: handleAssignToMeChange }, COPY_SPECIFIC.ASSIGNED_TO_ME)),
        React.createElement(When, { condition: selectedCount },
            React.createElement(Space, { size: Number(css.size24) },
                React.createElement(ConfirmDeleteButton, { buttonId: 'initiatives-table-archive-button', buttonLabel: COPY_SPECIFIC.ARCHIVE, cancelButtonProps: {
                        id: 'initiatives-table-archive-cancel-button'
                    }, confirmButtonProps: {
                        id: 'initiatives-table-archive-confirm-button',
                        value: COPY_SPECIFIC.ARCHIVE
                    }, onConfirm: handleBulkArchive, title: COPY_SPECIFIC.ARE_YOU_SURE_ARCHIVE_INITIATVES.replace('{0}', String(selectedCount)), type: 'link' }),
                React.createElement(When, { condition: !jiraIntegration },
                    React.createElement(InitiativeStatusSelector, { defaultValue: COPY_SPECIFIC.CHANGE_STATUS, id: 'initiatives-table-status-select', onChange: (statusId) => handleBulkChange({ initiativeStatusId: statusId }), showArrow: false, variant: 'borderless' })),
                React.createElement(UserSelector, { id: 'initiatives-table-user-select', onSingleChange: (id) => handleBulkChange({ assignedTo: Number(id) }), placeholder: COPY_SPECIFIC.CHANGE_OWNER, selectionRequired: true })))));
};
